import React, { useState, useEffect } from 'react';
import {
    Text, View, Image, StyleSheet
} from 'react-native';
import { store } from "../../store/store";
import { doPost } from '../../utils/services/api/API';
import { getTransactionDatetime } from '../../utils/services/DateTimeUtils';

import { CommonHeader } from "../../utils/widgets/CommonWidget/CommonHeader";

import Lottie from "lottie-react-web";

import AppTheme from '../../AppTheme';
import TextStyle from '../../TextStyle';
import AppStyles from "../../AppStyles";
import Colors from '../../utils/constants/AppColors';

import no_transaction from '../../assets/animation/no_transaction.json'

import * as Animatable from "react-native-animatable";
import * as AlertService from "../../utils/services/AlertLoaderService";

import * as CommonUtils from '../../utils/services/CommonUtils';
import * as StatusCheck from '../../utils/services/transaction/CheckTransactionStatus';

const TransactionHistory = (props) => {
    const [transactionList, updateTransactionList] = useState([]);
    const [render, updateRender] = useState(false);
    const [walletDetails, setwalletDetails]: any = useState({});

    const getTransactionList = () => {
        AlertService.loaderModal.setLoader(true);
        updateRender(false);
        var params = {
            "orderBy": "id",
            "status": "",
            "appVersionCode": 0,
            "pageSize": 0,
            "includeEventData": true,
            "ascending": false,
            "pageNumber": 0,
            "appGUID": ""
        }; doPost('payment/list_transaction', params).then(
            (response: any) => {
                updateTransactionList(response)
                AlertService.loaderModal.setLoader(false);
                updateRender(true);
            }, error => console.log(error)
        )
    }
    useEffect(() => {
        getTransactionList();
        const reduxState = store.getState();
        if (reduxState && reduxState.hasOwnProperty('walletDetails')) {
            setwalletDetails(reduxState.walletDetails)
        }
    }, [])

    return (
        <View>

            <CommonHeader navigation={props.navigation} title='Transaction History'></CommonHeader>

            <View style={[AppStyles.flexRowCenter,
            styles.balanceCard,
            { borderWidth: 2, borderColor: Colors.grey.text }]}>
                <View>
                    <View style={[AppStyles.flexRowStart,
                    { justifyContent: "center" }]}>
                        <Image source={{
                            uri: CommonUtils.getImagePath('/images/icons/aayu_cash_icon.svg'),
                            width: 16, height: 16
                        }} />
                        <Text style={[TextStyle.text16,
                        { marginLeft: 6 }]}>
                            Aayu Cash</Text></View>
                    <Text style={[TextStyle.text12,
                    { color: Colors.grey.text, marginLeft: 22 }]}>
                        Valid forever</Text>
                </View>
                <Text>
                    <Text style={[styles.walletBalance, TextStyle.text16b]}>
                        <Text>&#8377;</Text> {parseInt(walletDetails?.['balance'])?.toFixed(0)}</Text>
                </Text>
            </View>

            {
                render ? transactionList.length == 0 ?
                    <View style={{ marginHorizontal: 32, alignItems: "center", marginTop: "25%" }}>
                        <Lottie
                            options={{ animationData: no_transaction }}
                            width={AppTheme.appWidth - 128} />
                        <Text style={[TextStyle.text16b, { marginTop: 16, marginBottom: 12 }]}>No transactions yet</Text>
                    </View> :
                    transactionList.map((transaction, i) => (
                        transaction['type'] == 3 && transaction['amount'] == 0 ?
                            <View key={transaction['ts'] ?? i} /> :
                            <Animatable.View animation="fadeIn"
                                key={transaction['ts'] ?? i}
                                duration={AppTheme.transitionDuration}
                                delay={i ? (i * AppTheme.transitionDuration) / 20 : 0}
                                useNativeDriver
                                style={[styles.transaCard,
                                {
                                    backgroundColor: i % 2 == 0 ?
                                        Colors.blue.lightTint :
                                        Colors.white
                                }]}>
                                <View style={{ flex: 1, flexDirection: 'column' }}>
                                    <Text style={styles.tranMedium}>
                                        {StatusCheck.getTransactionStatusText(transaction)}</Text>
                                    <Text style={styles.tranTime}>
                                        {getTransactionDatetime(transaction['ts'])}</Text>
                                </View>
                                <Text style={[styles.transAmount,
                                { color: StatusCheck.getTransactionStatusColor(transaction) }]}>
                                    <Text style={[{ fontSize: 20 }]}>{StatusCheck.getTransactionSign(transaction)}</Text> &#8377; {transaction['amount']}
                                </Text>
                            </Animatable.View>
                    )) : <View />
            }
        </View>
    )
}

const styles = StyleSheet.create(CommonUtils.addFontFamilylato({
    members: {
        flex: 1, flexDirection: 'row', marginHorizontal: 15, marginBottom: 16,
        justifyContent: 'flex-start', shadowColor: "rgba(0, 0, 0, 0.35)", shadowOffset: { width: 0, height: 5, },
        shadowOpacity: 0.48, shadowRadius: 24, elevation: 18, paddingVertical: 9, paddingHorizontal: 8,
        borderRadius: 4
    },
    addMember: { fontSize: 16, color: Colors.primary, paddingLeft: 8 },
    walletBalance: {
        color: Colors.grey.text,
        paddingLeft: 4,
        paddingRight: 10
    },
    balanceCard: {
        borderColor: '#e0e0e0', borderWidth: 1, padding: 16, margin: 16, marginTop: AppTheme.headerHeight + 16,
        justifyContent: 'space-between', backgroundColor: '#f1fbe5', borderRadius: 12
    },
    transaCard: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-around',
        padding: 16,
        alignItems: 'stretch',
    },
    noTransactions: { color: Colors.grey.text, fontSize: 14 },
    tranMedium: { fontSize: 14, color: '#cc00000', paddingBottom: 5 },
    tranTime: { fontSize: 12, color: '#707070', },

    transAmount: {
        fontSize: 16, alignSelf: "center",
        alignItems: "center", alignContent: "center", textAlign: 'center', width: 100, color: '#60b500'
    }
}))

export default TransactionHistory;